// extracted by mini-css-extract-plugin
export default {"modal":"ProductDetailsModal_modal__j7z7v","content":"ProductDetailsModal_content__SuN9H","closeBtnContainer":"ProductDetailsModal_closeBtnContainer__Q3OAH"};